<template>
  <div>
    <V3ChangePassword v-if="$store.state.showChangePassword"></V3ChangePassword>
    <V3RebateTypeMoney v-if="$store.state.showRebateTypeMoney"></V3RebateTypeMoney>
    <V3Bag v-if="showBag" @hidebagpage="hidebagpage"></V3Bag>
    <div v-if="!$store.state.showChangePassword && !$store.state.showRebateTypeMoney && !showBag" id="v3Mine">
      <div id="v3MineTopDiv">
        <img id="v3MineTopBg" src="~assets/img/SdkV3/MineTopBg.png">
        <div id="v3MineTopContentDiv">
          <img id="v3MineAvatar" src="~assets/img/SdkV3/MineTopAvatar.png" style="object-fit: scale-down;" />
          <div id="v3MineRoleDiv">
            <!-- <img src="~assets/img/SdkV3/MineTopBg.png" style="width: 100%;height: 100%;z-index: 1199;"> -->
            <div style="display:flex;flex-direction:row;align-items: center;">
              <span style="color:white;font-size: small;font-weight: bold;">{{ $store.state.roleInfoData.roleName
              }}</span>
              <img style="height:25px;width: 25px;object-fit: scale-down;margin-left: 5px;"
                  src="~assets/img/SdkV3/Wecaht.png" @click="wxBind()">
            </div>
            <div style="margin-top:2px;">
              <span style="color:#FCDA82;font-size: x-small;">{{ $store.state.roleInfoData.level }}级</span>
              <span style="color:#FCDA82;font-size: x-small;margin-left: 5px;">{{ $store.state.roleInfoData.serverName
              }}</span>
              <span style="color:#FCDA82;font-size: xx-small;margin-left: 5px;">{{ $store.state.userInfoData.rolereg
              }}</span>
            </div>
          </div>

        </div>
      </div>
      <div id="v3MineMiddleDiv">
        <img id="v3MineRebateBg" src="~assets/img/SdkV3/MineBigRebateBg.png"
          style="object-fit: scale-down;width: 130px;height: 130px;" />
        <span style="position:absolute;top:25px;color: black;font-size: xx-small;">我的红包</span>
        <span
          style="position:absolute;top:45px;color: red;font-size: medium;">{{ $store.state.userInfoData.moneysum }}元</span>
        <img id="v3MineCashOutBtn" src="~assets/img/SdkV3/CashOutBtn.png"
          style="object-fit: scale-down;width: 100px;height: 22px;position:absolute;bottom:30px;"
          @click="showRebateTypeMoneyPage()" />
      </div>
      <div id="v3MineEndDiv">
        <div style="padding-left:10px">
          <label style="font-size:small;font-weight:bold">| 常规功能</label>
        </div>
        <div id="v3MissionsDiv">
          <img src="~assets/img/SdkV3/ModifyPsw.png" style="width:60px;height:55px;" @click="changePasswordClick()">
          <img src="~assets/img/SdkV3/Mission.png" style="width:60px;height:55px;margin-left: 20px;"
            @click="missionClick()">
          <img src="~assets/img/SdkV3/Online.png" style="width:60px;height:55px;margin-left: 20px;"
            @click="onLineClick()">
            <!-- 是否开启了礼包 1-->
          <img v-if="$store.state.initData.giftstatus == '1'" src="~assets/img/SdkV3/Bag.png" style="width:60px;height:55px;margin-left: 20px;"
            @click="onBagClick()">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/network/request';
import getRequestParams from "@/signParams";
import V3ChangePassword from './changepassword/V3ChangePassword.vue';
import V3RebateTypeMoney from './rebateTypeMoney/V3RebateTypeMoney.vue';
import V3Bag from './bag/V3Bag.vue';

import utils from '@/utils';
export default {
  data() {
    return {
      serviceType: "",
      showBag: false
    }
  },
  components: {
    V3ChangePassword, V3RebateTypeMoney, V3Bag
  },
  created: function () {
    this.serviceType = utils.getUrlKey("serviceType")

  },
  methods: {
    showRebateTypeMoneyPage() {
      let storeCommomParams = this.$store.state.commonParameters;
      // console.log("基本参数 ： ", storeCommomParams);
      let signParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_MONEY,
        params: {
          data: signParams // 在url后面加上&data=[signParams具体内容]
        },
      }).then(res => {
        console.log("金额接口返回", res);
        let rebateTypeMoneyList = JSON.parse(res['moneyList'])
        // this.rebateTypeMoneyList.push({"typeid":1,"money":0.99,"name":"登录红包"})
        // this.rebateTypeMoneyList.push({"typeid":2,"money":3.99,"name":"瓜分红包"})
        // this.rebateTypeMoneyList.push({"typeid":3,"money":5.99,"name":"等级红包"})
        this.$store.commit('updateRebateTypeMoneyShowState', true)
        this.$store.dispatch("networkUpdateRebateTypeMoneyList", rebateTypeMoneyList)
      })
    },
    wxBind() {
      if (this.$store.state.userInfoData.wxuser == "1") {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "您已绑定过微信" })
        return
      }

      let storeCommomParams = this.$store.state.commonParameters
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res => {
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if ("qrcode" == res.type) {
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": true, "qrcodeUrl": qrcodeUrl })
        } else {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "暂无绑定方式" })
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": false, "qrcodeUrl": "" })
        }
      })
    },
    missionClick() {
      // 跳转到红包页面
      this.$emit("missionclick")
    },
    onBagClick(){
      // 打开礼包
      this.showBag = true
      // let bagList = []
      // bagList.push({'name': "专属豪礼1", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "1",})
      // bagList.push({'name': "专属豪礼2", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "0",})
      // bagList.push({'name': "专属豪礼3", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "0",})
      // bagList.push({'name': "专属豪礼4", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "1",})
      // bagList.push({'name': "专属豪礼5", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "1",})
      // bagList.push({'name': "专属豪礼6", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "0",})
      // bagList.push({'name': "专属豪礼7", 'content': '礼包内容：\n元宝*888，金币*88W，坐骑，培养石*10，强化石*100','status': "1",})
      // this.$store.dispatch("networkUpdateBagList", bagList)

      let storeCommomParams = this.$store.state.commonParameters
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let giftReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_GIFT,
        params: {
          data: giftReqParams
        },
      }).then(res => {
        let bagList = JSON.parse(res.giftList)
        console.log("礼包列表", bagList);
        this.$store.dispatch("networkUpdateBagList", bagList)
        this.showBag = true
      })
    },
    hidebagpage(){
      // 隐藏礼包
      this.showBag = false
    },
    onLineClick() {
      let that = this
      // 通知客户端打开客服
      // this.sendToClient('openService?')
      // 获取当前用户的充值总额   
      let storeCommomParams = this.$store.state.commonParameters;
      // console.log("基本参数 ： ", storeCommomParams);
      let signParams = getRequestParams({}, storeCommomParams);
      this.$store.commit('switchLoading', true)
      if ("qiyu" == this.serviceType) {
        request({
          url: this.urls.PAY_DETAIL,
          params: {
            data: signParams // 在url后面加上&data=[signParams具体内容]
          },
        }).then(res => {
          let userName = storeCommomParams['username']
          let gamename = storeCommomParams['gamename']
          let serverid = storeCommomParams['serverid']
          let rolename = storeCommomParams['rolename']
          let totalpay = res['totalpay']
          let dataStr = JSON.stringify([
            { "key": "real_name", "value": "无" },
            { "key": "mobile_phone", "hidden": true },
            { "key": "email", "value": "无" },
            { "key": "avatar", "label": "头像", "value": "https://ysf.qiyukf.net/operation/080659b993a45dd546fbd71efd5ef000" }, // 访客头像
            { "index": 0, "key": "account", "label": "账号", "value": userName },
            { "index": 1, "key": "gamename", "label": "游戏名", "value": gamename },
            { "index": 2, "key": "serverid", "label": "区服id", "value": serverid },
            { "index": 3, "key": "rolename", "label": "角色名", "value": rolename },
            { "index": 4, "key": "totalpay", "label": "充值总额", "value": totalpay + "" },
          ])
          console.log("数据dataStr == ", dataStr);
          // 使用七鱼客服H5版
          ysf('config', {
            uid: storeCommomParams['rid'],
            name: storeCommomParams['username'],
            mobile: storeCommomParams['phone'],
            data: dataStr,
            success: function () {     // 成功回调
              console.log("成功回调");
              that.url = decodeURIComponent(ysf('url'))
              that.$store.commit('switchLoading', false)
              that.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "正在打开客服..." })
              that.sendToClient('qiyuUrl?'.concat(JSON.stringify({ "qiyuUrl": that.url })))

              // window.location.href = that.url 
              // console.log(that.url);
              // that.showServiceCenter = true;
              // ysf('open');
            },
            error: function () {       // 错误回调
              // handle error
              console.log("错误回调");
            }
          });
        })
      } else {
        // QQ客服
        request({
          url: this.urls.CUSTOMER_SERVICE,
          params: {
            data: signParams // 在url后面加上&data=[signParams具体内容]
          },
        }).then(res => {
          that.$store.commit('switchLoading', false)
          that.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "正在打开客服..." })
          console.log("客服接口返回", res);
          that.sendToClient('openQQ?'.concat(JSON.stringify({ "qqUrl": "mqqwpa://im/chat?chat_type=wpa&uin=" + res['qq'] })))
        })
      }
    },
    changePasswordClick() {
      let phone = this.$store.state.commonParameters.phone;
      if (phone == "" || phone == "undefined") {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "改账号还未绑定手机，暂时无法修改密码" })
        return;
      }
      this.$store.commit('updateChangePasswordShowState', true)
    }
  }
}
</script>

<style>
#v3Mine {
  /* height: 100%; */
  width: 100%;
  height: 70vh;
}

/* #v3Mine img{
  object-fit: scale-down;
} */
#v3Mine button {
  margin-top: 5px;
  background: -webkit-linear-gradient(left, #FB6C34, #F84524);
  border-radius: 10px 10px 10px 10px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 50%;
  color: white;
  font-size: small;
  border: none;
}

#v3MineTopDiv {
  position: relative;
  height: 100px;
  width: 100%;
  align-items: Center;
  font-size: 0;
}

#v3MineTopBg {
  /* object-fit: fill; */
  /* background-color: #F84524; */
  height: 100%;
  width: 100%;
  position: absolute;
  display: block;
}

#v3MineTopContentDiv {
  z-index: 11;
  height: 100%;
  position: absolute;
  object-fit: scale-down;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  align-items: Center;
  /*垂直居中*/
}

#v3MineAvatar {
  width: 40px;
  height: 40px;
  /* margin-top: 30px; */
}

#v3MineRoleDiv {
  /* background-color: antiquewhite; */
  display: flex;
  flex-direction: column;
  padding-left: 5px;
}

#v3MineMiddleDiv {
  position: relative;
  padding-top: 20px;
  height: 150px;
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

#v3FlushDiv {
  flex: 1;
  justify-content: center;
  align-items: Center;
  display: flex;
  flex-direction: column;
}

#v3LoginDiv {
  flex: 1;
  justify-content: center;
  align-items: Center;
  display: flex;
  flex-direction: column;
}

#v3MineEndDiv {
  padding-top: 15px;
  display: flex;
  flex-direction: column;
}

#v3MissionsDiv {
  padding-left: 10px;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  /* align-items: baseline; */
}

#v3MissionsDiv img {
  object-fit: scale-down;
}</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/V3Mine.vue